import { SecondaryButton } from '@rikstv/shared-components';
import { FC } from 'react';
import { trackClickCheckOtherAddress } from '~/analytics/eventTracker';
import { Icon } from '~/components/shared';
import { FlexBox } from '~/components/shared/layout/FlexBox';
import { InternetCustomerAddress, useInternetFlowStore } from '../useInternetStore';
import { AddressSearchInput } from './AddressSearchInput';

import classes from '../InternetOfferSubPage.module.css';

export const DisabledsInputField: FC<{ selectedAddress: InternetCustomerAddress }> = ({ selectedAddress }) => {
  const setAvailabilityResponse = useInternetFlowStore((s) => s.setAvailabilityResponse);
  const setSelectedAddress = useInternetFlowStore((s) => s.setSelectedAddress);
  return (
    <FlexBox className={classes.addressContainer}>
      <AddressSearchInput disabled id="address-search-input" defaultValue={selectedAddress.description} />
      <SecondaryButton
        className={classes.whiteSecondaryBtn}
        onClick={() => {
          trackClickCheckOtherAddress();
          setAvailabilityResponse(undefined);
          setSelectedAddress(null);
        }}
      >
        Søk på en annen adresse&nbsp;{' '}
        <Icon type="search" color="white" size={1.5} style={{ fill: selectedAddress ? 'black' : 'var(--disabled-text)' }} />{' '}
      </SecondaryButton>
    </FlexBox>
  );
};
